/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdatedMaintenanceRecordRequest = {
  vin: string;
  sestCode: UpdatedMaintenanceRecordRequest.sestCode;
  replaceOdometer: number;
  replaceDate: string;
  source: UpdatedMaintenanceRecordRequest.source;
  isActive?: boolean;
};
export namespace UpdatedMaintenanceRecordRequest {
  export enum sestCode {
    _01 = '01',
    _02 = '02',
    _03 = '03',
    _04 = '04',
    _09 = '09',
    _18 = '18',
    _21 = '21',
  }
  export enum source {
    SERVICE_CENTER = 'SERVICE_CENTER',
    USER = 'USER',
    ADMIN = 'ADMIN',
  }
}

